import {
  addBreadcrumb,
  captureEvent,
  captureException,
  captureMessage,
  flush,
  init,
  logger,
  setTag,
  setUser,
  withSentryConfig,
} from '@sentry/nextjs';
import { ErrorBoundary } from '@sentry/react';

import { createInitClient, createLog, createMonitor, createMonitoringProvider } from './src';

export { browserTracingIntegration, IGNORED_CLIENT_ERRORS, isIgnoredError, isIgnoredEvent } from './src';

export const Log = createLog(logger);

export const initClient = createInitClient({ init, captureException });

export const Monitor = createMonitor({
  captureException,
  captureEvent,
  captureMessage,
  addBreadcrumb,
  flush,
  setUser,
  setTag,
  ErrorBoundary,
  withSentryConfig,
});

export const MonitoringProvider = createMonitoringProvider(setUser);
